<template>
  <div class="register-body">
    <img class="mobeil-title" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-title.png">
    <div class="question-box">
      <img class="mobeil-ip" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-ip.png">
      <img class="mobeil-footer" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-footer.png">
      <div class="dialog-back">
        <el-button size="mini" type="primary" @click="goBack">
          <div>返回</div>
          <div>Return</div>
        </el-button>
      </div>
      <img class="forgotPassword-title" src="https://pdsite.partydaysport.com/official_website/buyTickets/forgotPassword-title.png">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="Phone (電話):" prop="phone">
          <el-input placeholder="Please Enter Phone" v-model="form.phone" class="input-with-select" clearable>
            <el-select v-model="globalCode" slot="prepend" filterable>
              <el-option v-for="(item, index) in globalCodeOptions" :key="index"
                :label="'+' + item.dialCode + ' - ' + item.name" :value="item.dialCode"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="Password (新密碼):" prop="new_pwd">
          <el-input type="password" v-model="form.new_pwd" placeholder="Please Enter Password" show-password
            clearable></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password (確認密碼):" prop="repeatPassword">
          <el-input type="password" v-model="repeatPassword" placeholder="Please Enter Password" show-password
            clearable></el-input>
        </el-form-item>
        <div class="flex" style="justify-content: space-between;">
          <el-form-item label="Verification code (驗證碼):" prop="code">
            <el-input class="verifice-input" v-model="form.code" placeholder="Please Enter Verification code"
              clearable />
          </el-form-item>
          <div class="verifice-btn">
            <el-button v-if="isClickSendCode" @click="sendCode">
              <div class="verifice-cn">獲取驗證碼</div>
            </el-button>
            <el-button v-else>
              <div class="verifice-cn">倒數計時{{ countdown60Seconds }}s</div>
            </el-button>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="submitForm">
          <div class="cn">確認修改</div>
          <div class="en">Confirm modification</div>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { loginSendSms, updatePwd } from "@/api/index";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your password again for confirmation"));
      } else if (this.form.new_pwd !== this.repeatPassword) {
        callback(new Error("Password entered twice is inconsistent"));
      } else {
        callback();
      }
    };
    return {
      // 表单参数
      form: {},
      globalCode: "",//区号
      // globalCodeOptions: require('country-telephone-data').allCountries,
      globalCodeOptions: [
        {
          dialCode: "86",
          name: "China (中国)"
        },
        {
          dialCode: "852",
          name: "Hong Kong (香港)"
        },
      ],
      // 表单校验
      rules: {
        phone: [{ required: true, message: "Please Enter Phone", trigger: "blur" }],
        new_pwd: [{ required: true, message: "Please Enter Password", trigger: "blur" }],
        code: [{ required: true, message: "Please Enter Verification code", trigger: "blur" }],
        repeatPassword: [{ required: true, trigger: "blur", validator: validatePass }],
      },
      isClickSendCode: true,//倒计时60s
      countdown60Seconds: "",
      timer: "",
      loading: false,
      languageType: null,//语言类型
      repeatPassword: "",//确认密码
    };
  },
  mounted() {
    this.reset()
    this.getLanguageType()
  },
  methods: {
    // 表单重置
    reset() {
      this.form = {
        phone: undefined,
        new_pwd: undefined,
        code: undefined,
      };
      this.repeatPassword = "";
      this.globalCode = "86"
    },
    // 当前的语言
    getLanguageType() {
      // 缓存语言  1英文  2 繁体   3简体 
      var storageLang = localStorage.getItem('language');
      if (storageLang) {
        if (storageLang == 'cn') {
          this.languageType = 3
        } else if (storageLang == 'en') {
          this.languageType = 1
        } else if (storageLang == 'tc') {
          this.languageType = 2
        }
        return
      }
      // 浏览器语言
      var lang = navigator.language || navigator.userLanguage;
      if (lang.startsWith("zh")) {
        this.languageType = 3
      } else {
        this.languageType = 1
      }
    },
    // 发送验证码后60秒倒计时
    getCountdown60Seconds() {
      const TIME_COUNT = 60;
      this.countdown60Seconds = TIME_COUNT;
      this.isClickSendCode = false;
      this.timer = setInterval(() => {
        if (this.countdown60Seconds > 0 && this.countdown60Seconds <= TIME_COUNT) {
          this.countdown60Seconds--;
        } else {
          this.isClickSendCode = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 获取短信验证码
    sendCode() {
      //校验
      if (!this.form.phone) {
        this.$message({
          message: 'Please Enter Phone',
          type: 'error'
        });
        return;
      }
      // 60s倒计时后可以再次点击
      this.getCountdown60Seconds();
      loginSendSms({
        phone: '+' + this.globalCode + this.form.phone,
        type: this.languageType,// 1英文  2 繁体   3简体 
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: 'Verification code sent successfully, please check',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
          }
        })
    },
    // 提交表单
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true
          updatePwd({
            ...this.form,
            phone: '+' + this.globalCode + this.form.phone
          })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: 'Confirm succeeded',
                  type: 'success'
                });
                this.$router.replace('/')

              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error'
                });

              }
            }).finally(() => {
              this.loading = false
            })
        }
      });
    },
    // 返回
    goBack() {
      this.$router.back()
    }
  },
};
</script>
<style lang="less">
.input-with-select .el-select .el-input {
  width: 150px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item__label {
  font-size: 12px;
  line-height: 20px;
}

.el-input__inner,
.el-textarea__inner {
  font-size: 12px;
}

.el-button--primary {
  background-color: #000;
  border-color: #000;
}

.el-button--primary.is-plain {
  background-color: #fff;
  border-color: #000;
  color: #000;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: rgba(0, 0, 0, .8);
  border-color: rgba(0, 0, 0, .8);
}

.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background: #fff;
  border-color: rgba(0, 0, 0, .8);
  color: rgba(0, 0, 0, .5);
}

.dialog-back {
  position: absolute;
  right: 30px;
  top: 20px;
}

.forgotPassword-title {
  width: 70%;
  height: auto;
  margin-bottom: 10px;
}

.register-body {
  width: 100%;
  height: 100vh;
  background-image: url(https://pdsite.partydaysport.com/official_website/buyTickets/login-bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;


  .mobeil-title,
  .mobeil-footer,
  .mobeil-ip {
    display: none;
  }

  .question-box {
    width: 450px;
    height: 500px;
    position: fixed;
    right: 80px;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 15px;
    padding: 15px 30px 30px;
    background-color: #fff;
    box-sizing: border-box;


    .flex {
      display: flex;
    }

    .verifice-input {
      width: 230px;
    }

    .verifice-btn {
      margin-top: 21px;
      width: 150px;
      height: 40px;

      .el-button {
        width: 100%;
        height: 40px;
        padding: 0;
        background-color: #68DDF4;
        border: none;
        color: #fff;

        .verifice-cn {
          font-size: 11px;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .el-button {
      width: 100%;

      .en,
      .cn {
        font-size: 12px;
      }
    }
  }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {

  .el-select-dropdown__item {
    white-space: normal !important;
    word-break: break-all !important;
    // line-height: 1.5 !important;
    /* 增加行高 */
  }

  .el-select-dropdown {
    left: 2.5% !important;
    max-width: 95% !important;
  }

  .register-body {
    background-image: none;
    background-color: #d8d8d7;

    .mobeil-title,
    .mobeil-footer,
    .mobeil-ip {
      display: block;
    }

    .mobeil-title {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
    }

    .mobeil-footer {
      width: 330px;
      height: auto;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -50px;
      margin: auto;
    }

    .mobeil-ip {
      width: 250px;
      height: auto;
      position: absolute;
      top: -130px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 10;
      animation: jump 3s infinite ease-in-out;
      display: inline-block;
    }

    @keyframes jump {

      0%,
      100% {
        transform: translateY(0);
      }

      50% {
        transform: translateY(-20px);
      }
    }

    .dialog-back {
      right: 20px;
      top: 20px;
    }

    .question-box {
      width: 330px;
      height: 480px;
      position: fixed;
      left: 0;
      right: 0;
      top: 100px;
      padding: 20px;

      .verifice-input {
        width: 200px;
      }

      .verifice-btn {
        width: 80px;
      }
    }
  }
}
</style>